import { isSyncingUsers, isUserLoading, user } from 'core/selectors';
import { getUsers, syncUsers } from 'core/slices/users';
import { connect } from 'react-redux';
import Home from '../../../components/home/Home';

export default connect(
  state => ({
    user: user(state),
    isSyncingUsers: isSyncingUsers(state),
    isUserLoading: isUserLoading(state),
  }),
  { syncUsers, getUsers },
)(Home);
